import BaseScene from "../../scenes/BaseScene";

export default class CountDown extends Phaser.GameObjects.Container {
  three: Phaser.GameObjects.Text;
  two: Phaser.GameObjects.Text;
  one: Phaser.GameObjects.Text;
  step: number;
  countdownPaused: boolean;
  countdownActive: boolean;


  constructor(scene: BaseScene) {
    super(scene);

    this.setDepth(5);

    scene.add.existing(this);
    const style = scene.sponge.data.model.fonts.countdown;

    this.three = scene.add.text(
      scene.cameras.main.centerX,
      scene.cameras.main.centerY,
      "3",
      style
    );
    this.two = scene.add.text(
      scene.cameras.main.centerX,
      scene.cameras.main.centerY,
      "2",
      style
    );
    this.one = scene.add.text(
      scene.cameras.main.centerX,
      scene.cameras.main.centerY,
      "1",
      style
    );
    this.add([this.one, this.two, this.three]);
    this.one.alpha = this.two.alpha = this.three.alpha = 0;

    this.one.setOrigin(0.5).setStroke("#30aee4", 20);
    this.two.setOrigin(0.5).setStroke("#30aee4", 20);
    this.three.setOrigin(0.5).setStroke("#30aee4", 20);

    this.countdownPaused = false;
    this.countdownActive = false;
    
  }

  startCountDown(){
    this.one.alpha = this.two.alpha = this.three.alpha = 0;
    this.step = 3;
    this.countdownActive = true;
    this.countStep();
  }

  pauseCountDown(){
    this.countdownPaused = true;
  }

  resumeCountDown(){
    this.countdownPaused = false;
    this.updateStepCount();
  }

  updateStepCount(){
    if(this.countdownPaused){
      return;
    }

    this.step--;
    this.countStep();
  }

  countStep() {
    let num: Phaser.GameObjects.Text;

    switch (this.step) {
      case 3:
        num = this.three;
        break;
      case 2:
        num = this.two;
        break;
      case 1:
        num = this.one;
        break;
      case 0:
        this.countdownActive = false;
        this.emit("countdown-complete");
        return;
    }

    if(this.step > 0){
      num.setAlpha(1);

      this.scene.add.tween({
        targets: num,
        duration: 1000,
        alpha: 0,
        onComplete: () => {
          this.updateStepCount()
        },
      });
    }
    
  }
}
